import { CompaniesDirectoryPage } from "@/components/companies/companies-directory-page";

/** User-owned mutable account copies. */
export function AccountsPage() {
  return <CompaniesDirectoryPage scope="account" />;
}
